import { useState, useEffect } from "react";
import {
  Segment,
  Button,
  Icon,
  Label,
  Transition,
  Divider,
  Image,
  Form,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { buildStorageUrl } from "../../../../utils";
import { PostAnswer } from "../PostAnswer";
import { ReactionButton } from "../ReactionButton";
import { Answer } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./AnswerForm.form";
import moment from "moment";
import "moment/locale/es"; // Importa el idioma español
import "./ForumPost.scss";

const answerController = new Answer();

export function ForumPost(props) {
  const { post, isPage } = props;
  const { accessToken } = useAuth();
  const [isExpanded, setIsExpanded] = useState(isPage ? true : false);

  useEffect(() => {
    if (isPage) {
      setIsExpanded(true);
    }
  }, [isPage]);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        formValue.postId = post.id;
        await answerController.createAnswer(accessToken, formValue);
        Swal.fire({
          icon: "success",
          title: "Respuesta enviada",
          text: "Tu respuesta ha sido enviada y está pendiente de aprobación por un administrador.",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#2185d0",
        });
        // onReload();
        formik.resetForm();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const postDate = moment.utc(post?.createdAt).local();
  const now = moment.utc().local();
  const isOlderThanOneMonth = now.diff(postDate, "months") > 1;
  const formattedDate = isOlderThanOneMonth
    ? postDate.format("DD/MM/YYYY [a las] hh:mm a")
    : postDate.fromNow();

  return (
    <Segment className="forum-post">
      <div className="forum-post__card">
        <div className="forum-post__card-header">
          <div className="forum-post__card-avatar">
            <Image
              avatar
              centered
              size="tiny"
              src={buildStorageUrl(post.User?.avatar)}
            />
          </div>
          <div className="forum-post__card-header-info">
            <span className="forum-post__card-title">{post.title}</span>
            <span className="forum-post__card-author">
              {`${post.User?.firstname} ${post.User?.lastname} ${post.User?.secondLastname}`}{" "}
              - {post.Subject?.name}
            </span>
          </div>
          <span className="forum-post__card-date">{formattedDate}</span>
        </div>
        <div
          className="forum-post__card-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        {/* {post.tags && (
            <div style={{ marginTop: "0.5rem" }}>
              {post.tags.map((tag) => (
                <Label key={tag} size="tiny" style={{ marginRight: "0.5rem" }}>
                  {tag}
                </Label>
              ))}
            </div>
          )} */}
        <div className="forum-post__card-footer">
          <div className="forum-post__card-actions">
            <ReactionButton targetType="post" target={post} />
            {isPage ? (
              <Button labelPosition="right" size="tiny" as="div">
                <Button color="blue" size="tiny" as="div">
                  <Icon name="comment" />
                  Respuestas
                </Button>
                <Label basic color="blue" pointing="left">
                  {post.Answers?.length || 0}
                </Label>
              </Button>
            ) : (
              <Button
                labelPosition="right"
                onClick={() => setIsExpanded(!isExpanded)}
                size="tiny"
              >
                <Button color="blue" size="tiny">
                  <Icon name="comment" />
                  {isExpanded ? "Ocultar" : "Mostrar"} Respuestas
                </Button>
                <Label basic color="blue" pointing="left">
                  {post.Answers?.length || 0}
                </Label>
              </Button>
            )}
          </div>
          <Label
            className="forum-post__card-status"
            size="large"
            color={post?.solved ? "blue" : "grey"}
            content={post?.solved ? "Resuelta" : "Sin resolver"}
          />
        </div>
      </div>

      <Transition visible={isExpanded} animation="slide down" duration={300}>
        <div className="forum-post__answers">
          {isExpanded && (
            <>
              <Divider className="forum-post__divider" />
              {post.Answers?.map((answer) => (
                <PostAnswer key={answer.id} answer={answer} />
              ))}
              {(!post.Answers || post.Answers.length === 0) && (
                <p className="forum-post__no-answers">No hay respuestas aún</p>
              )}
              <Form
                className="forum-post__answers-form"
                onSubmit={formik.handleSubmit}
                reply
              >
                <Form.TextArea
                  name="content"
                  placeholder="Escribe una respuesta..."
                  onChange={formik.handleChange}
                  value={formik.values.content}
                  error={formik.errors.content}
                />
                <Form.Button
                  type="submit"
                  content="Añadir respuesta"
                  labelPosition="left"
                  icon="edit"
                  primary
                  loading={formik.isSubmitting}
                />
              </Form>
            </>
          )}
        </div>
      </Transition>
    </Segment>
  );
}
